var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author-title-con flexible jc-between aItem-center"},[_c('div',{staticClass:"breadbox"},[_c('el-breadcrumb',{attrs:{"separator":"/"}})],1),_vm._t("new-stroy")],2)}
var staticRenderFns = []

export { render, staticRenderFns }